import Youtube from './_components/youtube';
import defaultVideo from './_components/default';
import common from './common';

export default {
    createVideo(options) {
        if (this.isYoutube(options.src)) {
            return Youtube;
        }

        return defaultVideo;
    },
    isYoutube(src) {
        return common.getYoutubeId(src);
    }
};
